import { HTTP } from "@/axios.js"
import store from '@/store.js'
export default {
    userProfile: () => {
        return HTTP.get('/user_profile', {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    userProfileDetail: () => {
        return HTTP.get('/profile_edit', {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    editUserProfile: (data) => {
        return HTTP.post('/profile_update',data, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
}